import { NgForm } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { IErrorInfo } from './error-info';
import { ModalFormStatus } from './modal-form-status';

export class ModalHandle {
    constructor(modal: BsModalRef, status: ModalFormStatus = ModalFormStatus.Iddle) {
        this.modal = modal;
        this.status = status;
    }

    public time = new Date().toISOString();
    public modal: BsModalRef;
    public status: ModalFormStatus;
    public form: NgForm;
    public error?: Partial<IErrorInfo>;
}
